// extracted by mini-css-extract-plugin
export default {"Burger":"qN21SSGz","Burger--desktop":"eb42k_ka","Burger--mobile":"KhV_fhEE","burger__strip":"kojHBsd1","active":"IDnHL4et"};
    if(module.hot) {
      // 1717522983116
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  